import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { StringColumnModel } from '~components/dynamic-table/models/column-types/string-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { FormControlPipe } from '~core/pipes/form-control.pipe';
import { InputComponent } from '../../../form/input/input.component';

@Component({
    selector: 'arc-string-column',
    templateUrl: './string-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [InputComponent, MatTooltip, FormControlPipe]
})
export class StringColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> {
    get castedColumnModel(): StringColumnModel {
        return this.columnModel as StringColumnModel;
    }
}
